import { Card, Tooltip } from "antd";
import React, { useState } from "react";
import Icon from "../../../assets/Icon";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import { QuestionCircleOutlined } from "@ant-design/icons";
import Utils from "../../utils/Utils";
import { Link } from "react-router-dom";
// Out-of-window occurrences
function Integrity({ config, integrityInfo,loginQuery }) {
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleImageClick = (src) => {
    setEnlargedImage(src);
  };

  const closeModal = () => {
    setEnlargedImage(null);
  };

  return (
    <div className="mt-10">
      {" "}
      <div className="flex justify-between gap-4 items-center">
        <div className="flex gap-3 items-center font-semibold text-[1.275rem]">
          <p className="bg-[#206DC5] border inline-block p-3 rounded-xl">
            <Icon type="integrity-analysis-icon" width="18" height="19" />
          </p>
          <span>Integrity</span>
        </div>
        <div className="">
          <Link to={`/interview-analysis/?q=${loginQuery}&tab=fraud`}>
            <button className="flex items-center justify-center gap-2 px-4 py-3 bg-[#206DC5] text-white font-semibold rounded-md">
            <Icon type="report-eye-icon" width="28" height="22" />{" "}
              <span className="print:block md:block hidden text-[.95rem]">
                View Detailed Fraud Analysis
              </span>
            </button>
          </Link>
        </div>
      </div>
      {/* <div className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB] grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-5 p-5 rounded-md"> */}
      <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]">
        <p className="text-[#475467] text-lg font-semibold pb-2 flex items-center gap-3">
          Out-of-window occurrences:{"  "}
          <Tooltip title="Out-of-window occurrences / Total chances given">
            <span className="text-orange-400">
              {integrityInfo?.fraudOccurrenceChancesGiven -
                integrityInfo?.fraudOccurrenceChancesLeft}
              /{integrityInfo?.fraudOccurrenceChancesGiven}
            </span>
          </Tooltip>
        </p>

        {config?.screenRecordingRequired ? (
          <div className="snapshot-container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 rounded-md">
            {integrityInfo?.fraudulentSnapshotData?.length > 0 &&
              integrityInfo.fraudulentSnapshotData.map((item, i) => (
                <img
                  key={i}
                  src={item?.snapshotUrl}
                  alt=""
                  // width={200}
                  // height={100}
                  className="rounded-md cursor-pointer hover:scale-110 transition-all duration-200 ease-in-out"
                  onClick={() => handleImageClick(item?.snapshotUrl)}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ))}
          </div>
        ) : (
          <div className="mt-2 mx-auto">
            <p className="text-center flex justify-center">
              <Icon type="lock-orientation-icon" width="50" height="50" />
            </p>
            <p className=" text-[#475467] text-center mt-1">
              Upgrade/Enable to unlock all screen recording premium features.
            </p>
            <div className="text-[#475467] text-center">
              Contact{" "}
              <a
                href="mailto:support@hireplusplus.com"
                className="text-[#206DC5] hover:text-blue-400 font-medium"
              >
                support@hireplusplus.com
              </a>{" "}
              to Upgrade/Enable.
            </div>
          </div>
        )}
        {enlargedImage && (
          <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
            onClick={closeModal}
          >
            <img
              src={enlargedImage}
              alt="Enlarged"
              className="max-w-full max-h-full rounded-md"
              onClick={(e) => e.stopPropagation()}
            />
            <button
              className="absolute top-4 right-4 text-white text-2xl"
              onClick={closeModal}
            >
              &times;
            </button>
          </div>
        )}
      </Card>
      <Card className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]  w-full ">
        <div className="avoid-break flex print:flex-row md:flex-row flex-col justify-between gap-4 w-full">
          <Card className="print:w-[22rem] md:w-[22rem] w-full ">
            <div className="w-full text-[#475467]   font-semibold pb-2 flex items-center  flex-col  gap-3">
              <div className="text-xl text-center">
                Audio Anomaly Count{" "}
                <Tooltip
                  title={
                    <div>
                      <p>
                        Anomalies detected during the interview process. It can
                        be "Multiple Speaker Detection" or "Speaker Change
                        Detection" or "Audio Device Change Detection". View
                        "Fraud Section" of "Interview recording page" for more
                        details
                      </p>
                    </div>
                  }
                >
                  <QuestionCircleOutlined className=" cursor-pointer" />
                </Tooltip>
              </div>
              {"  "}
              <div className="text-orange-400 text-6xl">
                {integrityInfo?.audioAnomalyData?.length || 0}
              </div>
            </div>
          </Card>
          <Card className="print:w-[22rem] md:w-[22rem] w-full ">
            <div className="w-full text-[#475467]   font-semibold pb-2 flex items-center  flex-col  gap-3">
              <div className="text-xl text-center">
                Interview Session Rejoins{" "}
                <Tooltip
                  title={
                    <div>
                      <p>
                        Number of joining attempts where candidate joined and
                        continued for more than a minute.
                      </p>

                      <p>
                        <strong>Note: </strong>
                        Anything greater 1 will have less integrity score.
                        Higher the score lesser the integrity
                      </p>
                    </div>
                  }
                >
                  <QuestionCircleOutlined className=" cursor-pointer" />
                </Tooltip>
              </div>
              {"  "}
              <div className="text-orange-400 text-6xl">
                {integrityInfo?.totalInterviewRejoins <= 0
                  ? "NA"
                  : integrityInfo?.totalInterviewRejoins}
              </div>
            </div>
          </Card>
          <Card className="print:w-[22rem] md:w-[22rem] w-full text-[#475467]">
            <div className="font-semibold flex gap-2 justify-center items-center text-xl">
              IP Address List{"  "}
              <Tooltip
                title={
                  <div>
                    <p>
                      Total number of IP Addresses identified during the
                      interview process.
                    </p>

                    <p>
                      <strong>Note: </strong>
                      Anything greater than 1 will have less integrity score.
                      Higher the number of unique IPs, lesser the integrity.
                    </p>
                  </div>
                }
              >
                <QuestionCircleOutlined className=" cursor-pointer" />
              </Tooltip>
            </div>
            <div className="flex flex-col items-center  mt-1 max-h-[88px] text-xl scroll overflow-auto">
              {integrityInfo?.uniqueIpAddresses?.map((items, index) => (
                <p key={index} className="text-blue-500 font-semibold">
                  {items}
                </p>
              ))}
            </div>
          </Card>
        </div>
      </Card>
      {/* </div> */}
    </div>
  );
}

export default Integrity;
